import { GlobeIcon,MarkGithubIcon } from '@primer/octicons-react'
import React from 'react'
import './projects.css'

function ProjectCard({project}) {
  return (
    <div className="project-card">
      <div className="project-info">
        <label className="project-title">{project.title}</label>
        <div className="project-links">
          {project.demo&&(
            <a className="project-link" href={project.demo}>
            <div className="link-button">
            <GlobeIcon size={16} /> Demo
            </div>
          </a>
          )}
          {project.github && (
            <a className="project-link" href={project.github}>
            <div className="link-button">
            <MarkGithubIcon size={16} /> GitHub
            </div>
          </a>
          )}          
        </div>
        <p>{project.about}</p>
        <div className="project-tags">
          {project.tags.map((tag) => {
            return (
              <label className="tag"> {tag} </label>
            )
          })}
        </div>
      </div>
      <img src={project.image} alt={project.title} className="project-photo" />
    </div>
  )
}

export default ProjectCard
